export const OPPORTUNITY_CATEGORIES = [{
    value: '1',
    viewValue: 'Seeking'
}, {
    value: '2',
    viewValue: 'Offering'
}];
